import * as Tone from 'tone';
import LiveState from './LiveState';
class ClipSlot {
    constructor(track) {
        this.hasStopButton = true;
        this.clip = null;
        this.track = track;
    }
    fire() {
        if (this.clip) {
            this.clip.fire();
        }
        else if (this.hasStopButton) {
            let actionTime = Tone.TransportTime(Tone.Transport.ticks, 'i');
            actionTime = Tone.TransportTime(actionTime.quantize(LiveState.GlobalQuantization));
            const actionTicks = actionTime.toTicks();
            if (actionTicks <= Tone.Transport.ticks) {
                const quantizationTicks = Tone.TransportTime(LiveState.GlobalQuantization).toTicks();
                actionTime = Tone.TransportTime(actionTicks + quantizationTicks, 'i');
            }
            this.track.stop(actionTime);
        }
    }
    getClip() { return this.clip; }
    getTrack() {
        return this.track;
    }
    hasClip() {
        return !!this.clip;
    }
    clipFired(clip, time) {
        this.track._clipFired(clip, time);
    }
    clipStarted(clip, time) {
        this.track._clipStarted(clip, time);
    }
    insert(clip) {
        if (clip.clipSlot == null) {
            this.clip = clip;
            clip.clipSlot = this;
        }
        else {
            throw Error('Clip is already inserted into a clipslot');
        }
    }
}
export default ClipSlot;
//# sourceMappingURL=ClipSlot.js.map